import type { TypedClient } from '@platform/openapi';
import { usePageContext } from '../usePageContext.ts';
import { NewOrderForm } from './NewOrderForm.tsx';
import { OrderFormFrame } from './OrderFormFrame.tsx';

export type NewOrderPageProps = { api: TypedClient; onCreated: (orderId: string) => void };

export const NewOrderPage = ({ api, onCreated }: NewOrderPageProps) => {
  const { t } = usePageContext();
  return (
    <OrderFormFrame api={api} title={t('nav.newOrder')} context={t('newOrder.context')}>
      {(data) => <NewOrderForm api={api} {...data} onCreated={onCreated} />}
    </OrderFormFrame>
  );
};
